'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';
import ModalPortal from '@/components/ModalPortal';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

interface TeamMember {
  name: string;
  designation: string;
  profileLink?: string;
  media?: {
    desktop_media?: { url: string; alternativeText?: string }[];
  };
  description?: { children?: { text: string }[] }[];
}

interface StaffModalProps {
  teamMember: TeamMember;
  onClose: () => void;
}
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

// const getPlainText = (desc: TeamMember['description']) =>
//   (desc ?? [])
//     .map((block) => (block?.children ?? []).map((child) => child?.text || '').join(''))
//     .join('\n');

export default function StaffModal({ teamMember, onClose }: StaffModalProps) {
  return (
    <ModalPortal>
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-[1000]"
          onClick={onClose}
        />

        <motion.div
          initial={{ x: '100%' }}
          animate={{ x: 0, transition: { duration: 0.3, ease: 'easeOut' } }}
          exit={{ x: '100%', transition: { duration: 0.3, ease: [0.77, 0, 0.175, 1] } }}
          className="ml-auto fixed top-0 right-0 w-full md:w-[400px] h-full bg-[#B6C380] shadow-lg z-[1100] px-4 py-6 pb-0 overflow-y-auto custom-scroll"
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col h-full">
            <div className="flex justify-between items-center mb-16 text-[15px] font-light leading-none">
              <h2 className="text-[#2B332A]">Team</h2>
              <button
                onClick={onClose}
                className="text-[#2B332A] hover:text-white"
                aria-label="Close modal"
              >
                Close
              </button>
            </div>

            <h3 className="text-xl text-[#2B332A] mb-6 leading-6 font-light">{teamMember.name}</h3>

            <Image
              src={teamMember.media?.desktop_media?.[0]?.url || '/images/fallback.jpg'}
              alt={teamMember.media?.desktop_media?.[0]?.alternativeText || 'Team member image'}
              width={471}
              height={343}
              className="w-full"
            />

            <div className="text-[#2B332A] mt-8 pb-7 whitespace-pre-wrap text-[15px] leading-[23px] font-light indent-10 text-start blocksRenderer">
              {/* {getPlainText(teamMember.description) || 'No Description'} */}
              <BlocksRenderer content={teamMember.description as BlocksRendererProps['content']} />
            </div>
          </div>
        </motion.div>
      </>
    </ModalPortal>
  );
}